import { Component, Input, OnInit } from '@angular/core';
import { modalAnimations } from '@shared/animations/animations';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
    validateAsOneLower,
    validateAsOneSpecial,
    validateAsOneUpper,
} from '@shared/directives/validators/input.controls';
declare const zxcvbn: any;

@Component({
    selector: 'app-password-creation',
    templateUrl: './password-creation.component.html',
    animations: modalAnimations,
})
export class PasswordCreationComponent implements OnInit {
    @Input() label: string;
    @Input() labelRepeat: string;
    @Input() form = new FormGroup({});
    newPasswordScore = 0;

    ngOnInit(): void {
        const newPasswordControl = new FormControl();
        newPasswordControl.setValidators([
            validateAsOneLower(),
            validateAsOneUpper(),
            validateAsOneSpecial(),
            Validators.required,
            Validators.minLength(12),
        ]);
        this.form.addControl('newPassword', newPasswordControl);

        const repeatPasswordControl = new FormControl();
        repeatPasswordControl.setValidators([Validators.required]);
        this.form.addControl('repeatPassword', repeatPasswordControl);

        this.form.get('newPassword').valueChanges.subscribe((value) => {
            this.newPasswordChanged();
        });
    }

    newPasswordChanged() {
        this.newPasswordScore = zxcvbn(
            this.form.controls.newPassword.value
        ).score;
    }

    get newPassword() {
        return this.form.get('newPassword');
    }
    get repeatPassword() {
        return this.form.get('repeatPassword');
    }
}
